const serverConfig = {
  timestampOffset: (window?.SERVER_DATA?.serverTime ?? 0) - Date.now() || 0,
}

export default serverConfig
